import './../App.css';
import { useEffect, useState, useRef } from 'react';
import img1 from "../img/accueil-banner.png";
import greybg from "../img/greybg.jpg";
import { Link } from 'react-router-dom';
import { AcceuilToggleItems, AcceuilToggleItemsActive, CompaniesItem } from '../components/MainComponents';
import { nosValeurs, nosSolut, companyConfiance, teamImages } from '../constants/MyConstants';
import { useNavigate } from 'react-router-dom';
import Axios from 'axios'
import { apiUrl } from '../constants/Constants';



function Acceuil() {
    const [param, setParam] = useState(0);
  

    
    const [personsList, setPersonsList] = useState([]);
    const ref = useRef(null);

    const getPersonsApi = () => {
        Axios.get(apiUrl + 'getPersons.php')
            .then((responseJson) => {
                if (responseJson.data === '0 results') {
                    setPersonsList([])
                }
                else {
                    setPersonsList(responseJson.data)
                }
            }
            );
    }
   

    const navigate = useNavigate();

    const switchView = (val) => {
        if (val === 0) {
            setParam(0)
        } else if (val === 1) {
            setParam(1)
        } else if (val === 2) {
            setParam(2)
        } else {
            setParam(3)
        }
    }

    // Start of show on scroll function 

    window.addEventListener('scroll', reveal);
    function reveal() {
        var reveals = document.querySelectorAll('.myreveal');
        for (var i = 0; i < reveals.length; i++) {
            var windowheight = window.innerHeight;
            var revealtop = document.getElementById('containerEquipe').getBoundingClientRect().top;
            var revealpoint = windowheight / 3;
            if (revealtop != 0 && revealtop < (windowheight - revealpoint)) {
                reveals[i].classList.add('myactive');
                reveals[i].classList.remove('myreveal');
            }
        }
    }


    // End of show on scroll function

    useEffect(() => {
        document.getElementById("vieww1").classList.add('active'); document.getElementById("vieww2").classList.remove('active'); document.getElementById("vieww3").classList.remove('active'); document.getElementById("vieww4").classList.remove('active'); switchView(0);
        document.getElementById("nav-acceuil1").classList.add('navSelected'); document.getElementById("nav-quisommenous1").classList.remove('navSelected'); document.getElementById("nav-nosolutions1").classList.remove('navSelected'); document.getElementById("nav-carrieres1").classList.remove('navSelected'); document.getElementById("nav-contactez1").classList.remove('navSelected');
        document.getElementById("nav-acceuil").classList.add('navSelected'); document.getElementById("nav-quisommenous").classList.remove('navSelected'); document.getElementById("nav-nosolutions").classList.remove('navSelected'); document.getElementById("nav-carrieres").classList.remove('navSelected'); document.getElementById("nav-contactez").classList.remove('navSelected');
        document.documentElement.scrollTop = 0;
        getPersonsApi();

    }, [])



   

    return (
        <div id='mainAcceuil' >
            <div class="banner-parallax accueilMainContainer backgroundStyle1">
                <div class="overlay-colored  opacity-90"></div>
                <div class="slide-content">
                    <div class="first-banner" >
                        <div class="text-center first-banner-child">
                            {/* <p className='italic color-blue first-banner-title'>
                                People, Process, Productivity
                            </p> */}
                            <div className='animation-title italic color-blue first-banner-title'>
                                <div className='animation-p1'>
                                    People,&nbsp;
                                </div>
                                <div className='animation-p2'>
                                    Process,&nbsp;
                                </div>
                                <div className='animation-p3'>
                                    Productivity
                                </div>
                            </div>
                            <div class="color-blue  first-banner-desc">
                                Pro-P Group est un cabinet de conseil qui accompagne ses clients dans
                                l’optimisation de leurs processus et la transformation digitale
                            </div>
                            <div class="backgroundGreen backgroundGreenDesign radius marginTop50">
                                {nosValeurs.map((data, index) => {
                                    return (
                                        <div key={index} class="insideGreen">
                                            <div>
                                                <img class="shadowImg marginTop10" src={data.image2} alt="" />
                                            </div>
                                            <div class="displayFlex  marginTop10">
                                                <div class="raleway insideGreen-p color-white">{data.text}&nbsp;</div>
                                                <div class="raleway insideGreen-p color-white insideGreen-span"> {data.span}</div>
                                            </div>
                                        </div>
                                    )
                                })}

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container solutionsMain" >
                <div class="backgroundGreen backgroundGreenDesign3 radius">
                    {nosValeurs.map((data, index) => {
                        return (
                            <div key={index} class="insideGreen insideGreenAnimation">
                                <div>
                                    <img class="shadowImg marginTop10" src={data.image2} alt="" />
                                </div>
                                <div class="displayFlex  marginTop10">
                                    <div class="raleway insideGreen-p color-white">{data.text}&nbsp;</div>
                                    <div class="raleway insideGreen-p color-white insideGreen-span"> {data.span}</div>
                                </div>
                            </div>
                        )
                    })}

                </div>
                <div id="about" class="solutionsDiv">
                    <div class="solutionsDiv2">
                        <div className='text-title color-blue text-center bold'>Nos Solutions</div>
                        <div className='text-center solutionsP'>Pro-P propose une large gamme de service de développement de logiciels et de conseil dans le domaine IT pour adresser les exigences de ses clients.</div>
                    </div>
                </div>

                <div class="solutionsContainer">

                    <div className='acceuil-toggle'>


                        {
                            nosSolut.map((data, index) => {
                                return (
                                    <div key={index} class="text-center acceuil-toggle-item marginTop20">
                                        <AcceuilToggleItemsActive id={data.id} aria={data.aria} toggleView={() => { data.function(); switchView(index) }} image={data.image} title={data.text} />
                                    </div>)
                            })
                        }

                    </div>



                    <div id='descId' class="solutionsDesc ">
                        <div className='greenSeperatorLinefull3'></div>
                        {
                            nosSolut.map((data, index) => {
                                return (
                                    param === index && <div key={index} class="slide solutionsDesc-child">

                                        <div class="color-blue bold solutionsDesc-child-title">{data.text}</div>
                                        <div class="solutionsDesc-child-p">{data.p}</div>

                                    </div>
                                )
                            })

                        }
                    </div>
                </div>
            </div>
        

            <div class="container confianceContainer">

                <div class="text-center">
                    <div className="text-title color-blue bold">Ils nous font confiance</div>
                </div>
                <div class="row marginTop50">
                    {
                        companyConfiance.map((data, index) => {

                            return (
                                <div key={index} class="col-sm-3 col-xs-3 img-company-div">
                                    <img class=" img-company" src={data.image} alt="" />
                                </div>
                            )

                        })
                    }
                </div>
            </div>
            <div class="scroll-top-icon scroll-top myscroll-top cursor-pointer" onClick={() => window.scrollTo({top: 0, left: 0, behavior: 'smooth' })}><i class="fa fa-angle-up fa-2x"></i></div>
        </div>

    );
}

export default Acceuil;
